import { Project } from "../models/Project";
import client from "./axios";

const projectsUrl = `${window.__env.KRAKEND_URL}/v1/projects`;

interface Asset {
  id?: number;
  type: string;
}

export const Projects = {
  getProjects: (params?: URLSearchParams) => client.get<Project[]>(projectsUrl, { params }),
  getProject: (id: number) => client.get<Project>(`${projectsUrl}/${id}`),
  createProject: (project: Project) => client.post<Project>(projectsUrl, project),
  updateProject: (project: Project) => client.put<Project>(`${projectsUrl}/${project.id}`, project),
  deleteProject: (id: number) => client.delete(`${projectsUrl}/${id}`),
  addAsset: (id: number, asset: Asset) => client.post(`${projectsUrl}/${id}/${asset.type}s/${asset.id}`, {}),
  removeAsset: (id: number, asset: Asset) => client.delete(`${projectsUrl}/${id}/${asset.type}s/${asset.id}`),
}